import {Dialog, Flex, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import React, {forwardRef, useImperativeHandle, useState} from 'react';
import Lottie from 'react-lottie';
import recordAnimation from './record.json';
import playAnimation from './macroPlay.json';
import styles from '../../styles/MacroFooter.module.scss';
import {IconWithTooltip} from '../../../FormHeader/components/Menus/TopMenu';
import texts from '../../texts';
import {stopMacroMessage, stopRecording} from '../../actions/macroActions';
import {returnFocus} from '../../../../_shared/GWTBridge/invoke/genPage';
import {Tooltip} from '../../../../components/Common/Tooltip';

export type Footer = {
    showFooter: (isRecord?: boolean) => void;
    hideFooter: () => void;
};

export const MacroFooter = forwardRef<Footer>((props, ref) => {
    const [isShown, setIsShown] = useState(false);
    const [isRecording, setIsRecording] = useState(false);

    const showFooter = (isRecord = false) => {
        setIsRecording(isRecord);
        setIsShown(true);
        returnFocus();
    };

    useImperativeHandle(ref, () => {
        return {
            showFooter,
            hideFooter
        };
    });

    const hideFooter = () => {
        setIsShown(false);
    };

    const handleStop = () => {
        if (isRecording) {
            setIsShown(false);
            returnFocus();
            stopRecording();
        } else {
            stopMacroMessage();
        }
    };

    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: isRecording ? recordAnimation : playAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const content = (
        <Flex componentClasses={styles.content} justifyContent={'flex-start'}>
            <Tooltip
                delay={100}
                className={styles.tooltip}
                tooltip={
                    isRecording ? texts.footer_recordingTooltip : texts.footer_macroAciveToolip
                }
            >
                <Lottie options={lottieOptions} height={40} width={40} />
            </Tooltip>
            <Separator componentClasses={styles.separatorMargin} align="horizontal" />
            <IconWithTooltip
                delay={100}
                tooltipClassname={styles.tooltip}
                onClick={handleStop}
                tooltip={isRecording ? texts.footer_stopTooltip : texts.footer_stopMacroTooltip}
                componentClasses={styles.icon}
                icon={PriorityIcon.stopRecording}
            />
        </Flex>
    );

    return (
        isShown && (
            <Dialog
                componentClasses={styles.container}
                isOpen={isShown}
                content={content}
                draggable
                mask={false}
                closable={false}
            />
        )
    );
});
